import React from 'react';
import { NavText } from '../../NavBar/NavText';
import { useS4XMastheadContext } from '../../S4XMastheadProvider';
import { trackCat } from '../../NavBar/constants';
export var PrimaryLink = function (_a) {
    var href = _a.href, label = _a.label, imageUrl = _a.imageUrl, trackingLabel = _a.trackingLabel, openInNewTab = _a.openInNewTab, isActive = _a.isActive;
    var InteractiveElement = useS4XMastheadContext().InteractiveElement;
    if (imageUrl) {
        return (React.createElement("div", { style: { height: '24px' } },
            React.createElement(InteractiveElement, { href: href, trackingCategory: trackCat, openInNewTab: openInNewTab, trackingLabel: trackingLabel },
                React.createElement("img", { src: imageUrl, alt: label, height: "100%" }))));
    }
    return (React.createElement("div", { style: { height: '24px' } },
        React.createElement(InteractiveElement, { customComponent: NavText, isFocus: isActive, href: href, size: "xsmall", openInNewTab: openInNewTab, trackingCategory: trackCat, trackingLabel: trackingLabel, label: label })));
};
export default PrimaryLink;
